import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, mergeProps as _mergeProps, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "columns is-centered is-hidden-mobile" }
const _hoisted_3 = { class: "column is-5" }
const _hoisted_4 = { class: "steps" }
const _hoisted_5 = { class: "step-item is-completed is-info" }
const _hoisted_6 = { class: "step-marker" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "step-details" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "step-title" }, "Search")
], -1)
const _hoisted_9 = { class: "step-item is-info is-active" }
const _hoisted_10 = { class: "step-marker" }
const _hoisted_11 = { class: "icon" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "step-details" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "step-title" }, "Citations")
], -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "step-item" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "step-marker" }),
  /*#__PURE__*/_createElementVNode("div", { class: "step-details" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "step-title" }, "Pay Bill")
  ])
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "title is-4 is-spaced" }, "Citation results")
  ])
], -1)
const _hoisted_15 = { class: "columns" }
const _hoisted_16 = { class: "column" }
const _hoisted_17 = { class: "is-grey-background" }
const _hoisted_18 = { class: "columns" }
const _hoisted_19 = { class: "column" }
const _hoisted_20 = { class: "field" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Name", -1)
const _hoisted_22 = { class: "control" }
const _hoisted_23 = { class: "column" }
const _hoisted_24 = { class: "field" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Case", -1)
const _hoisted_26 = { class: "control" }
const _hoisted_27 = { class: "column" }
const _hoisted_28 = { class: "field" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Issuing Agency", -1)
const _hoisted_30 = { class: "control" }
const _hoisted_31 = { class: "columns" }
const _hoisted_32 = { class: "column" }
const _hoisted_33 = { class: "column is-3" }
const _hoisted_34 = { class: "box" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "title is-4 is-spaced" }, "Total")
  ])
], -1)
const _hoisted_36 = { class: "columns" }
const _hoisted_37 = { class: "column" }
const _hoisted_38 = { class: "level" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "level-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "level-item" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Citation Total")
  ])
], -1)
const _hoisted_40 = { class: "level-right" }
const _hoisted_41 = { class: "level-item" }
const _hoisted_42 = { class: "columns" }
const _hoisted_43 = { class: "column" }
const _hoisted_44 = { class: "level" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("div", { class: "level-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "level-item" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Amount Credited")
  ])
], -1)
const _hoisted_46 = { class: "level-right" }
const _hoisted_47 = { class: "level-item" }
const _hoisted_48 = { class: "columns" }
const _hoisted_49 = { class: "column" }
const _hoisted_50 = { class: "level" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "level-left" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "level-item" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Remaining Balance")
  ])
], -1)
const _hoisted_52 = { class: "level-right" }
const _hoisted_53 = { class: "level-item" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1)
const _hoisted_55 = { class: "columns" }
const _hoisted_56 = { class: "column is-align-items-flex-end" }
const _hoisted_57 = { class: "columns" }
const _hoisted_58 = { class: "column" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column has-text-right" }, [
    /*#__PURE__*/_createElementVNode("button", { class: "button is-info" }, "Pay bill")
  ])
], -1)
const _hoisted_60 = {
  key: 1,
  class: "container"
}
const _hoisted_61 = { class: "columns is-centered is-hidden-mobile" }
const _hoisted_62 = { class: "column is-5" }
const _hoisted_63 = { class: "steps" }
const _hoisted_64 = { class: "step-item is-completed is-info" }
const _hoisted_65 = { class: "step-marker" }
const _hoisted_66 = { class: "icon" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "step-details" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "step-title" }, "Search")
], -1)
const _hoisted_68 = { class: "step-item is-info is-completed" }
const _hoisted_69 = { class: "step-marker" }
const _hoisted_70 = { class: "icon" }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("div", { class: "step-details" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "step-title" }, "Citations")
], -1)
const _hoisted_72 = { class: "step-item is-info is-active" }
const _hoisted_73 = { class: "step-marker" }
const _hoisted_74 = { class: "icon" }
const _hoisted_75 = /*#__PURE__*/_createElementVNode("div", { class: "step-details" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "step-title" }, "Pay Bill")
], -1)
const _hoisted_76 = /*#__PURE__*/_createElementVNode("div", { class: "columns" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "column" }, [
    /*#__PURE__*/_createElementVNode("h1", { class: "title is-4 is-spaced" }, "Partial Payment Confirmation")
  ])
], -1)
const _hoisted_77 = { class: "columns" }
const _hoisted_78 = { class: "column" }
const _hoisted_79 = { class: "is-grey-background" }
const _hoisted_80 = { class: "columns" }
const _hoisted_81 = { class: "column" }
const _hoisted_82 = { class: "block" }
const _hoisted_83 = { class: "block" }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("strong", null, " By checking this box, you acknowledge the above requirement regarding making a partial payment.", -1)
const _hoisted_85 = { class: "block" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_o_icon = _resolveComponent("o-icon")!
  const _component_o_table_column = _resolveComponent("o-table-column")!
  const _component_o_table = _resolveComponent("o-table")!
  const _component_o_radio = _resolveComponent("o-radio")!
  const _component_o_field = _resolveComponent("o-field")!
  const _component_o_input = _resolveComponent("o-input")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!
  const _component_o_checkbox = _resolveComponent("o-checkbox")!
  const _component_o_button = _resolveComponent("o-button")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.showPartialConfirmation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, [
                      _createVNode(_component_o_icon, { icon: "check" })
                    ])
                  ]),
                  _hoisted_8
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, [
                      _createVNode(_component_o_icon, { icon: "circle-small" })
                    ])
                  ]),
                  _hoisted_12
                ]),
                _hoisted_13
              ])
            ])
          ]),
          _hoisted_14,
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.personsName), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.results.Overview.CaseNo), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _hoisted_29,
                      _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.displayCourtName), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_o_table, {
                data: _ctx.results.Assessments,
                striped: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_o_table_column, {
                    field: "TicketNumber",
                    label: "Citation #"
                  }, {
                    default: _withCtx((props) => [
                      _createTextVNode(_toDisplayString(props.row.TicketNumber), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_o_table_column, {
                    field: "Statute",
                    label: "Statute"
                  }, {
                    default: _withCtx((props) => [
                      _createTextVNode(_toDisplayString(props.row.Statute), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_o_table_column, {
                    field: "LineItemDescription",
                    label: "Description"
                  }, {
                    default: _withCtx((props) => [
                      _createTextVNode(_toDisplayString(props.row.LineItemDescription), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_o_table_column, {
                    field: "LineItemAmount",
                    label: "Amount"
                  }, {
                    default: _withCtx((props) => [
                      _createTextVNode(_toDisplayString(props.row.LineItemAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD',})), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_component_Form, {
                  onSubmit: _ctx.paybill,
                  "validation-schema": _ctx.schema
                }, {
                  default: _withCtx(() => [
                    _hoisted_35,
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.results.Overview.TotalAmount.toLocaleString('en-US', { style: 'currency', currency: 'USD',})), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _hoisted_45,
                          _createElementVNode("div", _hoisted_46, [
                            _createElementVNode("div", _hoisted_47, _toDisplayString(_ctx.results.Overview.AmountPaid.toLocaleString('en-US', { style: 'currency', currency: 'USD',})), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      _createElementVNode("div", _hoisted_49, [
                        _createElementVNode("div", _hoisted_50, [
                          _hoisted_51,
                          _createElementVNode("div", _hoisted_52, [
                            _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.results.Overview.FullPaymentAmountDue.toLocaleString('en-US', { style: 'currency', currency: 'USD',})), 1)
                          ])
                        ])
                      ])
                    ]),
                    _hoisted_54,
                    _createElementVNode("div", _hoisted_55, [
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(_component_o_field, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_o_radio, {
                              modelValue: _ctx.paymentType,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paymentType) = $event)),
                              "native-value": "full",
                              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setAmount('full'))),
                              label: 'Pay In Full (' + _ctx.results.Overview.FullPaymentAmountDue.toLocaleString('en-US', { style: 'currency', currency: 'USD',}) + ')'
                            }, null, 8, ["modelValue", "label"])
                          ]),
                          _: 1
                        }),
                        _withDirectives(_createVNode(_component_o_field, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_o_radio, {
                              modelValue: _ctx.paymentType,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paymentType) = $event)),
                              "native-value": "min",
                              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setAmount('min'))),
                              label: 'Pay Minimum (' + _ctx.minPayment.toLocaleString('en-US', { style: 'currency', currency: 'USD',}) + ')'
                            }, null, 8, ["modelValue", "label"])
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, !_ctx.disablePartialPayments]
                        ]),
                        _withDirectives(_createVNode(_component_o_field, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_o_radio, {
                              modelValue: _ctx.paymentType,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.paymentType) = $event)),
                              "native-value": "other",
                              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setAmount('other'))),
                              label: "Pay Other"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, !_ctx.disablePartialPayments]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_component_Field, {
                          name: "AmountToPay",
                          modelValue: _ctx.AmountToPay,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.AmountToPay) = $event))
                        }, {
                          default: _withCtx(({ field, meta, errorMessage }) => [
                            _createVNode(_component_o_field, {
                              label: "Amount To Pay",
                              class: "required has-text-left",
                              variant: errorMessage ? 'danger' : '',
                              message: errorMessage
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createVNode(_component_o_input, _mergeProps({
                                  placeholder: "Amount To Pay",
                                  "data-maska": "0.99",
                                  "data-maska-tokens": "0:\\d:multiple|9:\\d:optional",
                                  modelValue: meta.initialValue,
                                  disabled: _ctx.paymentType != 'other'
                                }, field, {
                                  class: "has-text-left",
                                  maxlength: "50"
                                }), null, 16, ["modelValue", "disabled"]), [
                                  [_directive_maska]
                                ])
                              ]),
                              _: 2
                            }, 1032, ["variant", "message"])
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ])
                    ]),
                    _hoisted_59
                  ]),
                  _: 1
                }, 8, ["onSubmit", "validation-schema"])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.showPartialConfirmation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
          _createElementVNode("div", _hoisted_61, [
            _createElementVNode("div", _hoisted_62, [
              _createElementVNode("div", _hoisted_63, [
                _createElementVNode("div", _hoisted_64, [
                  _createElementVNode("div", _hoisted_65, [
                    _createElementVNode("span", _hoisted_66, [
                      _createVNode(_component_o_icon, { icon: "check" })
                    ])
                  ]),
                  _hoisted_67
                ]),
                _createElementVNode("div", _hoisted_68, [
                  _createElementVNode("div", _hoisted_69, [
                    _createElementVNode("span", _hoisted_70, [
                      _createVNode(_component_o_icon, { icon: "check" })
                    ])
                  ]),
                  _hoisted_71
                ]),
                _createElementVNode("div", _hoisted_72, [
                  _createElementVNode("div", _hoisted_73, [
                    _createElementVNode("span", _hoisted_74, [
                      _createVNode(_component_o_icon, { icon: "circle-small" })
                    ])
                  ]),
                  _hoisted_75
                ])
              ])
            ])
          ]),
          _hoisted_76,
          _createElementVNode("div", _hoisted_77, [
            _createElementVNode("div", _hoisted_78, [
              _createElementVNode("div", _hoisted_79, [
                _createElementVNode("div", _hoisted_80, [
                  _createElementVNode("div", _hoisted_81, [
                    _createElementVNode("div", _hoisted_82, [
                      _createElementVNode("strong", null, _toDisplayString(_ctx.results.Overview.PartialPaymentInstallmentVerbiage), 1)
                    ]),
                    _createElementVNode("div", _hoisted_83, [
                      _createVNode(_component_o_checkbox, {
                        modelValue: _ctx.partialPaymentConfirmed,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.partialPaymentConfirmed) = $event))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_84
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_85, [
                      _createVNode(_component_o_button, {
                        onClick: _ctx.confirmPartialPaymentVerbiage,
                        disabled: !_ctx.partialPaymentConfirmed
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Continue")
                        ]),
                        _: 1
                      }, 8, ["onClick", "disabled"])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}